import { dom, library, config } from "@fortawesome/fontawesome-svg-core"

import * as regular from "@/packs/libs/font-awesome/regular"
import * as solid from "@/packs/libs/font-awesome/solid"
import * as light from "@/packs/libs/font-awesome/light"
import * as brands from "@/packs/libs/font-awesome/brands"

library.add(regular, solid, light, brands)

config.autoAddCss = false

document.addEventListener("turbo:load", () => dom.i2svg())
document.addEventListener("turbo:frame-load", (event) => dom.i2svg({ node: event.target }))

// One scan per frame, however many stream actions a response carries
let pendingScan = null

document.addEventListener("turbo:before-stream-render", (event) => {
  const render = event.detail.render

  event.detail.render = async (streamElement) => {
    await render(streamElement)
    pendingScan ??= requestAnimationFrame(() => {
      pendingScan = null
      dom.i2svg()
    })
  }
})
